import React, { useState } from 'react'
import './cartItem.css';
import { useContext } from 'react';
import {shopContext} from '../../context/shop-context';

function CartItem(props) {
  const {cartValue,AddToCart,RemoveToCart,updateValue}=useContext(shopContext);
  const [range,setrange]=useState(0);
  return (
    <div className='CartItems'>
       <img src={props.data.ProductImg} alt="" />
        <div className="description">
            <p>{props.data.ProductName}</p>
            <p>${props.data.Price}</p>
        </div>
        <div className="range">
        <button onClick={()=>{
          AddToCart(props.data.id)
        }}> + </button>
        <input type='number' onChange={(e)=>updateValue(props.data.id,e.target.value)} value={cartValue[props.data.id]}/>
        <button onClick={()=>{RemoveToCart(props.data.id)}}> - </button>
        </div>
    </div>
  );
}

export default CartItem;
